"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmbedTriggerComponentsMap = exports.EmbedShareStoryPlayerTrigger = exports.EmbedShareBarTrigger = exports.EmbedTriggerComponent = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const web_core_ui_1 = require("@snapchat/web-core-ui");
const shareDestinations_1 = require("../../shareDestinations");
const OffPlatformSharing_1 = require("../OffPlatformSharing");
const EmbedShareTriggers_module_css_1 = __importDefault(require("./EmbedShareTriggers.module.css"));
var EmbedTriggerComponent;
(function (EmbedTriggerComponent) {
    EmbedTriggerComponent["ShareBar"] = "ShareBar";
    EmbedTriggerComponent["StoryPlayer"] = "StoryPlayer";
})(EmbedTriggerComponent = exports.EmbedTriggerComponent || (exports.EmbedTriggerComponent = {}));
/**
 * EmbedShareBarTrigger is a trigger component meant to be used inside ShareBar component
 */
function EmbedShareBarTrigger({ handleClick, buttonSize }) {
    const EmbedIcon = shareDestinations_1.Embed.icon;
    return ((0, jsx_runtime_1.jsx)(web_core_ui_1.IconButton, { onClick: handleClick, size: buttonSize, label: (0, OffPlatformSharing_1.getShareIconLabel)(shareDestinations_1.Embed.id), children: (0, jsx_runtime_1.jsx)("div", { className: EmbedShareTriggers_module_css_1.default.icon, "data-testid": "embed-icon", children: (0, jsx_runtime_1.jsx)(EmbedIcon, {}) }) }));
}
exports.EmbedShareBarTrigger = EmbedShareBarTrigger;
/**
 * EmbedShareStoryPlayerTrigger is a trigger component meant to be used inside StoryPlayer component
 */
function EmbedShareStoryPlayerTrigger({ handleClick }) {
    const EmbedIcon = shareDestinations_1.Embed.icon;
    return ((0, jsx_runtime_1.jsx)("button", { type: "button", className: EmbedShareTriggers_module_css_1.default.playerIconContainer, onClick: handleClick, "aria-label": (0, OffPlatformSharing_1.getShareIconLabel)(shareDestinations_1.Embed.id), "data-testid": "embed-icon", children: (0, jsx_runtime_1.jsx)(EmbedIcon, {}) }));
}
exports.EmbedShareStoryPlayerTrigger = EmbedShareStoryPlayerTrigger;
exports.EmbedTriggerComponentsMap = {
    [EmbedTriggerComponent.ShareBar]: EmbedShareBarTrigger,
    [EmbedTriggerComponent.StoryPlayer]: EmbedShareStoryPlayerTrigger,
};
//# sourceMappingURL=EmbedTriggers.js.map